// 登录,退出
export const USER_POST_LOGIN = 'USER_POST_LOGIN';
export const USER_DELETE_LOGOUT = 'USER_DELETE_LOGOUT';
// 获取用户基本信息
export const USER_SET_PROFILE = 'USER_SET_PROFILE';
export const USER_GET_PROFILE = 'USER_GET_PROFILE';
export const USER_GET_USER_INFO = 'USER_GET_USER_INFO';

// 获取用户认证状态
export const USER_GET_AUTH_STATUS = 'USER_GET_AUTH_STATUS';
export const USER_SET_AUTH_STATUS = 'USER_SET_AUTH_STATUS';

// 获取图片验证码
export const USER_GET_CAPTCHA = 'USER_GET_CAPTCHA';
// 验证图片验证码
export const USER_VERIFY_CAPTCHA = 'USER_VERIFY_CAPTCHA';

// 获取上传图片的 policy
export const USER_GET_IMG_CONFIG = 'USER_GET_IMG_CONFIG';
export const USER_SET_IMG_CONFIG = 'USER_SET_IMG_CONFIG';

// 上传json 返回URL
export const UPLOAD_JSON_RETURN_URL = 'UPLOAD_JSON_RETURN_URL';
// 通过URL 获取json
export const GET_URL_JSON = 'GET_URL_JSON';
// 上传课件json返回 URL
export const UPLOAD_KEJIAN_JSON_RETURN_URL = 'UPLOAD_KEJIAN_JSON_RETURN_URL';

// 获取账号通讯信息
export const USER_GET_COMMUNICATION = 'USER_GET_COMMUNICATION';
export const USER_SET_COMMUNICATION = 'USER_SET_COMMUNICATION';

// 绑定手机
export const USER_BIND_PHONE = 'USER_BIND_PHONE';

// 是否有查看教学团队权限
export const USER_GET_TEAM_POWER = 'USER_GET_TEAM_POWER';
export const USER_SET_TEAM_POWER = 'USER_SET_TEAM_POWER';

// 获取用户收藏夹
export const USER_GET_FAVORITES_LIST = 'USER_GET_FAVORITES_LIST';

// 老师教学信息
export const USER_GET_TEACHING_INFO = 'USER_GET_TEACHING_INFO';
export const USER_SET_TEACHING_INFO = 'USER_SET_TEACHING_INFO';

// 作业、测评红点数量
export const USER_GET_RED_DOTS = 'USER_GET_RED_DOTS';
export const USER_SET_RED_DOTS = 'USER_SET_RED_DOTS';

// 是否显示智能规划
export const USER_GET_IS_INTELLIGENCE = 'USER_GET_IS_INTELLIGENCE';

// 获取旧测评数据
export const USER_GET_OLD_EVALUATION = 'USER_GET_OLD_EVALUATION';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_user.js